<div class="component-container container">
    <div class="finicity-description-container blue-border" [hidden]="loading">
        <div>
            <h1 class="font-mont-regular">Almost There!</h1>
            <div class="font-mont-book">
                For final approval, we have to verify the primary checking account you use for your business.
            </div>

            <div class="font-mont-book">
                To verify your checking account, we've partnered with a third party service, Finicity. Clicklease does
                not store or have access to your banking credentials.
            </div>

            <div class="font-mont-book">
                <span class="font-mont-book">Here's how it works:</span>
                <ol>
                    <li>Search for (and select) your bank.</li>
                    <li>Enter your login credentials.</li>
                    <li>Select the checking account you use for your business.</li>
                    <li>You're done! You'll receive your final decision in a few short minutes.</li>
                </ol>
            </div>

            <div class="font-mont-book">
                <span class="font-mont-book">Forgot your bank login?</span>
                Click <span class="font-mont-book cursor-pointer"
                    (click)="sendFinicityVerifyBankAccountEmail();">here</span> to
                receive an email with a link to verify your bank account.
            </div>

            <div class="font-mont-book">
                <span class="font-mont-regular">Need Help? Have Questions?</span>
                <div class="font-mont-book">Call <span class="font-mont-book">1-888-509-5592</span></div>
            </div>
        </div>
    </div>
    <div class="finicity-description-container" [hidden]="!loading">
        <div>
            <img src="/assets/images/icons/finicity_loading.svg" alt="finicity loading" />
            <h1 class="font-mont-regular">Thank you!</h1>
            <div class="font-mont-book">
                Thank you for submitting your bank information. We are verifying your account to make sure it meets our
                minimum qualifications for an approval. This usually takes less than a minute. We will notify you of
                your status on this screen.
            </div>

            <div class="font-mont-book">
                We will also send you an email when verification is complete.
            </div>

            <div class="font-mont-book">
                <div class="font-mont-book">
                    If you have any questions about this process, you can chat us
                    <span class="font-mont-book">here</span>
                    or contact us at
                    <span class="font-mont-book">1-888-509-5592</span>
                </div>
            </div>
        </div>
    </div>
    <app-what-makes-us-different [hidden]="!loading"></app-what-makes-us-different>
    <div class="finicity-iframe-container" [hidden]="loading">
        <div class="finicityIframe" id="finicityIframe"></div>
    </div>
</div>